import type { PrybarTheme } from "@prybar/core";

// HealthOS brand tokens (teal-600 accent, navy text) as literal values, since
// the command bar renders in a portal that may not inherit CSS variables.
export const healthOsPrybarTheme: Partial<PrybarTheme> = {
  accentColor: "#14818f",
  accentColorMuted: "rgba(20, 129, 143, 0.10)",
  textColor: "#0a1f3a",
  textMuted: "rgba(10, 31, 58, 0.55)",
  panelBackground: "rgba(255, 255, 255, 0.98)",
  overlayBackground: "rgba(10, 31, 58, 0.10)",
  borderColor: "rgba(20, 129, 143, 0.20)",
  fontFamily: '"Inter Tight", "Inter", system-ui, -apple-system, sans-serif',
  colorScheme: "light",
};
